import { IonButton, IonCol, IonRow, IonSpinner } from '@ionic/react';
import { useState, useContext, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Btn from '../../../components/Btn';
import InputCard from '../components/inputCard';
import classes from './styles.module.scss';
import { GlobalContext } from '../../../context/provider';
import { forgotPassword, verifyPassword } from '../../../context/actions/user';
import {
  VERIFYPASSWORD,
  VERIFYPASSWORD_ERROR,
} from '../../../context/actions/types';
import AuthLayout from '../components/AuthLayout';
import { RiLockPasswordFill } from 'react-icons/ri';
import ErrorToast from '../../../components/error_toast';
import { MdEmail } from 'react-icons/md';

const VerifyPassword: React.FC = (props: any) => {
  const history = useHistory();
  const { email } = props.location && props.location.state ;
  const [loading, setLoading] = useState(false);
  const { userState, userDispatch } = useContext<any>(GlobalContext);
  const [counter, setCounter] = useState(60);
  const [error, setError] = useState<{
    state: boolean;
    message: string | null;
  }>({
    state: false,
    message: null,
  });
  const [code, setCode] = useState(new Array(6).fill(''));
  const inputsRef = useRef<any>([]);

  useEffect(() => {
    if (userState?.verifyPassword) {
      const _code = code.join(',')?.replace(/,/g, '');
      const res = userState.verifyPassword;
      userDispatch({ type: VERIFYPASSWORD, payload: null });
      const info = { code: _code, email };
      history.push({
        pathname: '/resetpassword',
        state: info,
      });
    }
    if (userState?.verifyPasswordError) {
      setError({
        state: true,
        message: userState?.verifyPasswordError?.response?.data.message,
      });
      userDispatch({ type: VERIFYPASSWORD_ERROR, payload: null });
    }
    setLoading(false);
  }, [userState?.verifyPassword, userState?.verifyPasswordError]);

  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [counter]);

  const resendCode = async (e: any) => {
    e.preventDefault();
    setCounter(60);
    await forgotPassword({ email })(userDispatch);
  };
  const handleChange = (index: number, value: string) => {
    if (!/^[a-zA-Z0-9]$/.test(value) && value !== '') return;
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e: any) => {
    e.preventDefault();
    const pasteData = e.clipboardData
      .getData('text')
      .slice(0, 6)
      .replace(/[^a-zA-Z0-9]/g, '');
    if (pasteData.length === 6) {
      setCode(pasteData.split(''));
      inputsRef.current[5]?.focus();
    }
  };

  const handleSubmit = async () => {
    const _code = code.join(',')?.replace(/,/g, '');
    setLoading(true);
    await verifyPassword({ code: _code, email })(userDispatch);
  };

  return (
    <AuthLayout>
      <ErrorToast
        message={error.message!}
        isOpen={error.state}
        position={'bottom'}
        type="error"
        onClose={() => {
          setError({ state: false, message: null });
        }}
      />
      <section className="w-full h-auto flex flex-col items-center justify-center md:px-[35%] px-6">
        <div className="w-[25dvw] md:w-[8dvw] h-auto aspect-square rounded-full bg-white flex  items-center justify-center mt-4 p-8 md:p-10 overflow-hidden">
          <MdEmail size="100%" className="text-secondary" />
        </div>
        <div className="w-full flex flex-col items-center justify-center font-roboto text-primary mt-4 py-2 text-center">
          <h2 className="text-2xl md:text-3xl font-medium ">
            Check your email
          </h2>
          <p className="text-base font-light mt-2 ">
            We’ve sent a verification code to
          </p>
          <p className="text-base font-medium mt-2  text-secondary">{email}</p>
        </div>
        <div className="w-full flex  items-center justify-center mt-4">
          {code.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputsRef.current[index] = el)}
              type="text"
              value={digit}
              maxLength={1}
              className="w-11 h-12 md:w-12 text-center text-lg border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={(e) => handleChange(index, e.target.value)}
              onPaste={handlePaste}
            />
          ))}
        </div>
        <div className="w-full flex  items-center justify-center mt-4 font-roboto text-primary py-2 text-center">
          <p className="text-base font-light mr-2 ">
            Didn’t receive the email? :
          </p>

          {counter ? (
            <div className=" font-light mr-2 ">{counter}</div>
          ) : (
            <div
              className="text-blue-500 font-light mr-2 cursor-pointer"
              onClick={resendCode}
            >
              Resend
            </div>
          )}
        </div>
        <div className="w-full flex  items-center justify-center mt-4">
          <IonButton
            type="submit"
            onClick={handleSubmit}
            color="secondary"
            expand="block"
            fill="solid"
            className="w-full font-roboto text-base font-medium"
            disabled={code.join(',')?.replace(/,/g, '').length < 6 || loading}
          >
            {loading && <IonSpinner slot="end"></IonSpinner>}
            Submit
          </IonButton>
        </div>
        <div className="w-full flex  items-center justify-center my-4">
          <IonButton
            type="submit"
            color="primary"
            fill="clear"
            className="w-auto font-roboto text-base font-normal"
          >
            <Link to="/login" className="!text-primary !hover:text-secondary">
              Back to Login
            </Link>
          </IonButton>
        </div>
      </section>
    </AuthLayout>
  );
};

export default VerifyPassword;
